export enum SortOptions {
  NAME_ASC = 'A-Z',
  NAME_DESC = 'Z-A',
  CREATED_AT_ASC = 'Oldest',
  CREATED_AT_DESC = 'Newest',
}

// ===========================================================================
// Report Table Filter Enums
// ===========================================================================

export enum DateFilterType {
  allIncludingBlanks = 'allIncludingBlanks',
  allExcludingBlanks = 'allExcludingBlanks',
  blankOnly = 'blankOnly',
  range = 'range',
}
